import React from 'react';
import './HelpPage.css';

const HelpPage: React.FC = () => {
  return (
    <div className="help-page">
      <h2>Getting Started</h2>
      <div className="help-content">
        <div className="help-section">
          <h3>How to Connect</h3>
          <p>Use your mining software to connect to our stratum servers:</p>
          <div className="code-block">
            stratum+tcp://kaspapool.cryptoware.uk:[PORT]
          </div>
          <p>Use your wallet address as the username and anything for the password.</p>
          <p>For worker id, use this format for the username: <strong>WALLET_ADDRESS.WORKER_ID</strong></p>
        </div>
        
        <div className="help-section">
          <h3>Pool Fees</h3>
          <p>We charge competitive fees for our mining services. Check each pool's specific fee structure in the pools section.</p>
        </div>
        
        <div className="help-section">
          <h3>Payouts</h3>
          <p>Automatic payouts are processed regularly based on your accumulated balance and the pool's minimum payout threshold.</p>
        </div>

        <div className="help-section">
          <h3>Mining Software Configuration</h3>
          <p>Popular mining software configurations:</p>
          <div className="code-block">
            # For Bitcoin (SHA256) <br />
            ./cgminer --url stratum+tcp://kaspapool.cryptoware.uk:3333 --user YOUR_WALLET_ADDRESS --pass x
          </div>
        </div>

        <div className="help-section">
          <h3>Variable Difficulty</h3>
          <p>Our pools support variable difficulty (vardiff) to optimize your mining experience based on your hashrate.</p>
          <p>Use <strong style={{ color:'green' }}>D=xxx</strong> in the password section to set your prefered static diff.</p>
        </div>

        <div className="help-section">
          <h3>Support</h3>
          <p>If you need assistance, please contact our support team:</p>
          <ul style={{ color: '#94a3b8', marginLeft: '1rem' }}>
            <li>Email: support@kaspapool.cryptoware.uk</li>
            <li>Discord: Join our community server</li>
            <li>Check your miner stats using the lookup tool on the home page</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;